module.exports = __webpack_public_path__ + "static/Arconic_Foundation-753d715721e1c5c6261d5b21da9fd91b.png";